import _define_property from "@swc/helpers/src/_define_property.mjs";
import { ENVIRONMENT } from "../types/EnvironmentType.js";
var REGION_PLACEHOLDER = "{region}";
var _obj;
/**
 * The base url for the API endpoint.
 */ var API_ENDPOINT_URL = (_obj = {}, _define_property(_obj, ENVIRONMENT.dev, "https://apidev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj, ENVIRONMENT.stg, "https://apistg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj, ENVIRONMENT.production, "https://api".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj, ENVIRONMENT.hipaa, "https://apihipaa.cloud.coveo.com"), _obj);
var _obj1;
/**
 * The base url for the platform application.
 */ var APPLICATION_PLATFORM_BASE_URL = (_obj1 = {}, _define_property(_obj1, ENVIRONMENT.local, "https://local.stratus.coveo.com:8481"), _define_property(_obj1, ENVIRONMENT.dev, "https://platformdev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj1, ENVIRONMENT.stg, "https://platformstg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj1, ENVIRONMENT.production, "https://platform".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj1, ENVIRONMENT.hipaa, "https://platformhipaa.cloud.coveo.com"), _obj1);
var _obj2;
/**
 * The base url for the commerce hub application.
 */ var APPLICATION_COMMERCE_HUB_BASE_URL = (_obj2 = {}, _define_property(_obj2, ENVIRONMENT.local, "https://commercedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com/?platform=https://local.stratus.coveo.com:8481")), _define_property(_obj2, ENVIRONMENT.dev, "https://commercedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj2, ENVIRONMENT.stg, "https://commercestg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj2, ENVIRONMENT.production, "https://commerce".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj2, ENVIRONMENT.hipaa, "https://commercehipaa.cloud.coveo.com"), _obj2);
var _obj3;
/**
 * The base url for the knowledge hub application.
 */ var APPLICATION_KNOWLEDGE_HUB_BASE_URL = (_obj3 = {}, _define_property(_obj3, ENVIRONMENT.local, "https://knowledgedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com/?platform=https://local.stratus.coveo.com:8481")), _define_property(_obj3, ENVIRONMENT.dev, "https://knowledgedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj3, ENVIRONMENT.stg, "https://knowledgestg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj3, ENVIRONMENT.production, "https://knowledge".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj3, ENVIRONMENT.hipaa, "https://knowledgehipaa.cloud.coveo.com"), _obj3);
/**
 * The application host roots used with region.
 */ var APPLICATION_HOST_ROOTS_USED_WITH_REGION = [
    "platformdev",
    "platformstg",
    "platform",
    "commercedev",
    "commercestg",
    "commerce",
    "knowledgedev",
    "knowledgestg",
    "knowledge"
];
var _obj4;
/**
 * The base url for the cloud search.
 */ var CLOUD_SEARCH_BASE_URL = (_obj4 = {}, _define_property(_obj4, ENVIRONMENT.local, "https://local.stratus.coveo.com:8481"), _define_property(_obj4, ENVIRONMENT.dev, "https://searchdev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj4, ENVIRONMENT.stg, "https://searchstg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj4, ENVIRONMENT.production, "https://search".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")), _define_property(_obj4, ENVIRONMENT.hipaa, "https://searchhipaa.cloud.coveo.com"), _obj4);
var _obj5;
/**
 * The base url for the online help.
 */ var ONLINE_HELP_BASE_URL = (_obj5 = {}, _define_property(_obj5, ENVIRONMENT.local, "https://docs.coveo.com/"), _define_property(_obj5, ENVIRONMENT.dev, "https://docs.coveo.com/"), _define_property(_obj5, ENVIRONMENT.stg, "https://docs.coveo.com/"), _define_property(_obj5, ENVIRONMENT.production, "https://docs.coveo.com/"), _define_property(_obj5, ENVIRONMENT.hipaa, "https://docs.coveo.com/"), _obj5);
var _obj6;
/**
 * Status page beautiful urls (http only)
 */ var STATUS_PAGE_URL = (_obj6 = {}, _define_property(_obj6, ENVIRONMENT.local, "https://status.cloud.coveo.com"), _define_property(_obj6, ENVIRONMENT.dev, "https://status.cloud.coveo.com"), _define_property(_obj6, ENVIRONMENT.stg, "https://status.cloud.coveo.com"), _define_property(_obj6, ENVIRONMENT.production, "https://status.cloud.coveo.com"), _define_property(_obj6, ENVIRONMENT.hipaa, "https://status-hipaa.cloud.coveo.com"), _obj6);
var _obj7;
/**
 * Status page https api urls (https)
 */ var STATUS_PAGE_API_URL = (_obj7 = {}, _define_property(_obj7, ENVIRONMENT.local, "https://jgdmnlhfjdlf.statuspage.io"), _define_property(_obj7, ENVIRONMENT.dev, "https://jgdmnlhfjdlf.statuspage.io"), _define_property(_obj7, ENVIRONMENT.stg, "https://jgdmnlhfjdlf.statuspage.io"), _define_property(_obj7, ENVIRONMENT.production, "https://jgdmnlhfjdlf.statuspage.io"), _define_property(_obj7, ENVIRONMENT.hipaa, "https://y7lrnsy2bjgf.statuspage.io"), _obj7);
var _obj8;
/**
 * The hostnames for the UI of our applications.
 */ var UI_HOSTNAMES = (_obj8 = {}, _define_property(_obj8, ENVIRONMENT.hipaa, [
    "hipaa",
    "commercehipaa.cloud.coveo.com",
    "knowledgehipaa.cloud.coveo.com",
    "platformhipaa.cloud.coveo.com"
]), _define_property(_obj8, ENVIRONMENT.production, [
    "production",
    "commerce".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "knowledge".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "platform".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")
]), _define_property(_obj8, ENVIRONMENT.stg, [
    "stg",
    "commercestg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "knowledgestg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "platformstg".concat(REGION_PLACEHOLDER, ".cloud.coveo.com")
]), _define_property(_obj8, ENVIRONMENT.dev, [
    "dev",
    "commercedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "knowledgedev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    "platformdev".concat(REGION_PLACEHOLDER, ".cloud.coveo.com"),
    // docs website
    "localhost:3000",
    "docs.admin-ui.coveo.com"
]), _obj8);
var _obj9;
/**
 * The alternative domains for the usage analytics.
 */ var USAGE_ANALYTICS_ALT_DOMAINS = (_obj9 = {}, _define_property(_obj9, ENVIRONMENT.local, []), _define_property(_obj9, ENVIRONMENT.dev, [
    "https://platformdev".concat(REGION_PLACEHOLDER, "0.cloud.coveo.com"),
    "https://platformdev".concat(REGION_PLACEHOLDER, "1.cloud.coveo.com")
]), _define_property(_obj9, ENVIRONMENT.stg, [
    "https://platformstg".concat(REGION_PLACEHOLDER, "0.cloud.coveo.com"),
    "https://platformstg".concat(REGION_PLACEHOLDER, "1.cloud.coveo.com")
]), _define_property(_obj9, ENVIRONMENT.production, [
    "https://platform".concat(REGION_PLACEHOLDER, "0.cloud.coveo.com"),
    "https://platform".concat(REGION_PLACEHOLDER, "1.cloud.coveo.com")
]), _define_property(_obj9, ENVIRONMENT.hipaa, [
    "https://platformhipaa".concat(REGION_PLACEHOLDER, "0.cloud.coveo.com"),
    "https://platformhipaa".concat(REGION_PLACEHOLDER, "1.cloud.coveo.com")
]), _obj9);
export var URLConstant = Object.freeze({
    API_ENDPOINT_URL: API_ENDPOINT_URL,
    APPLICATION_PLATFORM_BASE_URL: APPLICATION_PLATFORM_BASE_URL,
    APPLICATION_COMMERCE_HUB_BASE_URL: APPLICATION_COMMERCE_HUB_BASE_URL,
    APPLICATION_KNOWLEDGE_HUB_BASE_URL: APPLICATION_KNOWLEDGE_HUB_BASE_URL,
    APPLICATION_HOST_ROOTS_USED_WITH_REGION: APPLICATION_HOST_ROOTS_USED_WITH_REGION,
    CLOUD_SEARCH_BASE_URL: CLOUD_SEARCH_BASE_URL,
    ONLINE_HELP_BASE_URL: ONLINE_HELP_BASE_URL,
    STATUS_PAGE_URL: STATUS_PAGE_URL,
    STATUS_PAGE_API_URL: STATUS_PAGE_API_URL,
    UI_HOSTNAMES: UI_HOSTNAMES,
    USAGE_ANALYTICS_ALT_DOMAINS: USAGE_ANALYTICS_ALT_DOMAINS
});

//# sourceMappingURL=URLConstant.js.map